// src/pages/Home.jsx
import React from "react";
import KakaoAdFit from "../components/KakaoAdfit";
import {
  CircleFadingPlus,
  Users,
  Sparkles,
  ChevronRight,
  ShieldCheck,
  ScanSearch,
  Handshake
} from "lucide-react";

export default function Home() {
  return (
    <div className="mx-auto max-w-6xl px-4 lg:px-0 lg:pt-5 lg:pb-3 pt-5 pb-5">
      {/* 상단 레이아웃 */}
      <section className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row">
        {/* 좌측 (히어로 + CTA + 모바일 광고 + 특징 3개 + PC 광고) */}
        <div className="flex flex-1 flex-col">
          {/* Hero */}
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 py-1 text-[11px] text-zinc-600 shadow-sm dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-300">
              <Sparkles className="h-3.5 w-3.5" />
              Arkive - 로스트아크 전투 분석 기록실
            </div>

            <h1 className="mt-6 md:mt-12 text-[26px] font-bold !leading-[1.2] sm:text-3xl md:text-5xl">
              모르고 보면{" "}
              <span className="text-indigo-600 dark:text-indigo-400">모르둠</span>,
              <br />
              알고 보면{" "}
              <span className="text-indigo-600 dark:text-indigo-400">완벽히 아르고스</span>
            </h1>

            <p className="mt-3 md:mt-4 max-w-2xl text-sm sm:text-base text-zinc-600 dark:text-zinc-300">
              전투 분석기 화면을 자동으로 인식하고 저장합니다. 저장된 자료는 직업별 평균 지표를 만드는데 활용됩니다.
            </p>

            {/* CTA: 모바일 풀폭, 데스크톱 자동폭 */}
            <div className="mt-6 md:mt-10 flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-2.5 sm:gap-3">
              <a
                href="/lobby#create"
                className="btn btn-primary"
              >
                <CircleFadingPlus className="h-4 w-4" /> 공격대 생성
              </a>
              <a
                href="/lobby#join"
                className="btn"
              >
                <Users className="h-4 w-4" /> 공격대 참여
              </a>
              <a
                href="/faq#q1"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-1 rounded-2xl px-4 py-3 text-sm font-medium text-indigo-600 hover:underline dark:text-indigo-400"
              >
                인식 안될 때 체크리스트 <ChevronRight className="h-4 w-4" />
              </a>
            </div>

            {/* 광고: 모바일 전용 300×250 x2 — CTA 바로 아래 */}
            <div className="mt-5 md:hidden flex flex-col gap-4 items-center">
              <div className="w-full h-[100px] relative">
                <KakaoAdFit unit="DAN-ctovZzTuaeHqmmcq" width={320} height={100} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"/>
              </div>
              <div className="w-full h-[100px] relative">
                <KakaoAdFit unit="DAN-80ctx4XrFCkLXhPs" width={320} height={100} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"/>
              </div>
            </div>
          </div>

          {/* 하단 특징 3개: 모바일 패딩 축소, md 이상 넉넉하게 */}
          <section className="mt-8 md:mt-12 md:max-w-[728px] md:pb-7">
            <div className="flex flex-col gap-4 md:flex-row md:gap-6">
              <div className="flex-1 rounded-2xl border border-zinc-200 bg-white p-4 md:p-6 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
                <div className="flex items-center gap-2">
                  <ScanSearch className="h-5 w-5 text-indigo-500" />
                  <h3 className="font-semibold text-sm md:text-base">화면 인식 & 매칭</h3>
                </div>
                <p className="mt-2 text-xs md:text-sm text-zinc-600 dark:text-zinc-300">
                  화면을 읽고, 저장된 데이터와 비교해 정확도를 높입니다.
                </p>
              </div>

              <div className="flex-1 rounded-2xl border border-zinc-200 bg-white p-4 md:p-6 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
                <div className="flex items-center gap-2">
                  <ShieldCheck className="h-5 w-5 text-indigo-500" />
                  <h3 className="font-semibold text-sm md:text-base">나만의 아카이브</h3>
                </div>
                <p className="mt-2 text-xs md:text-sm text-zinc-600 dark:text-zinc-300">
                  본인 기록은 본인만 접근 가능. 통계엔 익명으로만 반영됩니다.
                </p>
              </div>

              <div className="flex-1 rounded-2xl border border-zinc-200 bg-white p-4 md:p-6 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
                <div className="flex items-center gap-2">
                  <Handshake className="h-5 w-5 text-indigo-500" />
                  <h3 className="font-semibold text-sm md:text-base">공대원들과 함께</h3>
                </div>
                <p className="mt-2 text-xs md:text-sm text-zinc-600 dark:text-zinc-300">
                  공대원들과 기록을 공유하고 평균 지표를 확인하세요.
                </p>
              </div>
            </div>
          </section>

          {/* 광고: PC 전용 728×90 x2 — 특징 아래로 배치 */}
          <div className="mt-6 hidden md:flex flex-col gap-6 md:max-w-[728px]">
            <KakaoAdFit unit="DAN-rpwx66dufjfQ6CDo" width={728} height={90} />
            <KakaoAdFit unit="DAN-aHTnS2jlGQNjdScU" width={728} height={90} />
          </div>
        </div>

        {/* 우측 레일 광고 (md 이상만) */}
        <aside className="hidden md:flex md:w-[300px]">
          <div className="ml-auto flex w-[300px] flex-col items-center gap-6 justify-end">
            <KakaoAdFit unit="DAN-GwV0qgLZdWaSDI6L" width={300} height={250} />
            <KakaoAdFit unit="DAN-T9vIDnNJqP2HutQN" width={300} height={250} />
          </div>
        </aside>
      </section>
    </div>
  );
}
